import React,{ useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import AdminSidebar from '../../../components/nav/AdminSidebar'
import { toast } from 'react-toastify'
import Loading from '../../../components/otros/Loading'


import { createTipoActivo } from '../../../functions/api/tipoActivos'


const initialState = {
    tipo_activo:'',
    activo:true
}




  
const CreateTipoActivo = () => {
    const [loading,setLoading] = useState(false)
    const [activo,setActivo] = useState(initialState)


    let {user} = useSelector((state) =>({...state}))
    let navigate = useNavigate ()



    useEffect(() => {
        setLoading(true)
        setLoading(false)
    }, [])

    
    const handleChange = (e) =>{
        setActivo({...activo, [e.target.name]:e.target.value})
    }

    const { tipo_activo } = activo

    const submitActivo = (e) =>{
        e.preventDefault()
        
        createTipoActivo(user.token,activo )
        .then( r => {
            toast.success('Activo creado exitosamente')
            setActivo([])
            navigate('/admin/datos-maestros/activos')
        }
        )
        .catch( err =>
            
                toast.error(err.response.data)
            )
    }



  return (
    <div> 
        <AdminSidebar />
        {loading ? (
          
        <div className="home">
          <Loading />
        </div>
        ):(
            <div className="home">
                <div className='navCentro'>
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item">
                        <i class="fa-solid fa-ship"></i> ACTIVOS</li>
                        <li className="breadcrumb-item"> Crear categoria activos</li>
                    </ol>
                    <div className="row navTab">
                        <div className="col-md-12 navTabItem">
                            <Link to='/admin/datos-maestros/categoria-activos'><i class="fa-solid fa-chevron-left mr-2"></i>Atras</Link>
                        </div>
                    </div>
                </div>

                <div className='row'>
                <div className="col-md-12">
                        <form className='formFormat1'>
                            <label>Nombre del Tipo de Activo</label>
                            <input name='tipo_activo' value={tipo_activo} onChange={handleChange}  />
                            

                            <button className='formButton1' onClick={submitActivo} >Guardar</button>
                        </form>
                        
                    </div>
                </div>
            </div>
        )}
    </div>
  )
}

export default CreateTipoActivo